export default class TestReportModel{
    setNO: number[] | undefined
    deliveryNoteNO: string[] | undefined
    stockistCertNO: string[] | undefined
    lotNO: string[] | undefined
    millCertNO: string[] | undefined
    heatNO: string[] | undefined
    id: string[] | undefined
}